





















































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { News, StatusEnum } from "@/services/news/types";
import { getAllNews, setStatus } from "@/services/news/newsService";
import { newsFields } from "@/components/news/fields/newsFields";
import NewsDeleteModal from "@/components/news/modals/NewsDeleteModal.vue";
import AddNewsModal from "@/components/news/modals/AddNewsModal.vue";
import NewsPreviewModal from "@/components/news/modals/NewsPreviewModal.vue";
import { RoleEnum } from "@/store/authentication/types";
const namespace: string = "authentication";

@Component({
    components: { NewsDeleteModal, AddNewsModal, NewsPreviewModal }
})
export default class NewsComponent extends Vue {
    @Getter("authorize", { namespace }) authorize: any;
    roles = RoleEnum;
    // Local state
    news = [] as Array<News>;
    isBusy = false;
    fields = newsFields;
    sortBy = "name";
    sortDesc = false;
    statusEnum = StatusEnum;

    // filter options
    searchQuery = "";

    // lifecycle hooks

    public created() {
        this.fetchData();
    }

    // computed
    get filteredData() {
        return this.news && this.news
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }
    // methods

    deleteNews(id: string) {
        (this.$refs.newsDeleteModal as any).open(id);
    }

    previewNews(id: string, name: string) {
        (this.$refs.previewNewsModal as any).open(id, name);
    }

    addNews() {
        (this.$refs.addNewsModal as any).open();
    }

    fetchData() {
        this.isBusy = true;
        getAllNews().then((response: any) => {
            this.news = response;
            this.isBusy = false;
        });
    }

    updateNews(newsType: string, id: string) {
        this.$router.push({
            name: "UpdateNews",
            params: {
                id: id,
                newsType: newsType
            }
        });
    }

    toggleActive(item: News) {
        if (item.status === this.statusEnum.Active) {
            setStatus(item.id, this.statusEnum.Disabled).then(() => {
                this.fetchData();
            });
        } else {
            setStatus(item.id, this.statusEnum.Active).then(() => {
                this.fetchData();
            });
        }
    }
}
